module.exports = __webpack_public_path__ + "static/media/fixed_voice_arrow_select_up.a6a25bd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_arrow_select_up.svg
// module id = 3172
// module chunks = 0